import styled, { css } from 'styled-components';

import { mediaQuery, Button } from '@catalyze/ui';

export const StyledForm = styled.form`
    width: 100%;
    height: 100%;
    margin-top: 1rem;
`;

export const StyledButton = styled(Button)`
    width: 10.375rem;
    display: block;
    margin: 2rem auto 0;
    ${mediaQuery(
        2,
        css`
            width: 14.75rem;
        `
    )}
`;
